import { FileReference } from 'Domain/Model/FileReference/FileReference';

export const SEARCH_FILE_REFERENCES_SUCCESS = 'SEARCH_FILE_REFERENCES_SUCCESS';

interface IFindFileReferencesSuccess {
  fileReferences: Record<string, FileReference>,
  request: {},
  response: {},
}

export const searchFileReferencesSuccess = ({ fileReferences, request, response }: IFindFileReferencesSuccess) => ({
  type   : SEARCH_FILE_REFERENCES_SUCCESS,
  payload: { fileReferences },
  meta   : {
    request,
    response,
  }
});
